import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AUTH_MODE = (process.env.REACT_APP_AUTH_MODE || 'okta')
  .trim()
  .toLowerCase()
  .split(/\s+/)[0];
const AUTH_BYPASS_ENABLED = AUTH_MODE === 'bypass';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const user = localStorage.getItem('user');

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const userData = JSON.parse(user);

    if (!AUTH_BYPASS_ENABLED && userData.auth_method === 'local-bypass') {
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('okta_api_token');
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Check if token is expired
    if (userData.expires_at) {
      const expiresAt = new Date(userData.expires_at).getTime();
      if (Date.now() > expiresAt) {
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('okta_api_token');
        return <Navigate to="/login" state={{ from: location }} replace />;
      }
    }
  } catch {
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;